// DABug Component Builder

<template>
	<div class="main">
		<div class="title wi8_font">DABug Builder</div>



	</div>
</template>

<script>
export default {

}
</script>

<style scoped>
	.main {
		height: 100%;
		background-color: #FCFCEE;
		padding: 5px;
		border: solid 0px #009;
	}
	.title {
		color: #63F;
	}
</style>
